module.exports = __webpack_public_path__ + "static/media/MOTIVATION_INT_EXT_NEG.36374da9.md";